export default __webpack_public_path__ + "static/media/mg-title-cn.bce62bdc.webp";